import { useRef, useState } from "react";
import { MapPin } from "react-feather";
import { BiMapPin } from "react-icons/bi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { CardContent } from "semantic-ui-react";
import {
  getOtherRefDetails,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import { MAP_TYPES } from "../../const";
import Button from "../input/Button";
import Input from "../input/Input";
import SearchDropdown from "../input/SearchDropdown";
import MapComponent from "../maps/MapComponent";
import Tab from "../Tab";
import { locationApprovalValidation } from "../validations/locationCreation";
import { cityStartsWith } from "../../api/cityApi";
import { createLocationApprovalRequest } from "../../api/locationApprovalApi";

const ApproveLocation = ({ handleDrawerClose, setUpdateNeeded }) => {
  const userData = useSelector((state) => state.user.userDetails);
  const user = useSelector((state) => state.user);
  const [tab, setTab] = useState(1);
  const locRef = useRef();
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [submitErrors, setSubmitErrors] = useState({});

  const [location, setLocation] = useState({});
  const [lorCustomer, setLorCustomer] = useState("");
  const [lorPlant, setLorPlant] = useState("");
  const [lorDescription, setLorDescription] = useState("");
  const [lorLon, setLorLon] = useState("");
  const [lorLat, setLorLat] = useState("");
  const [lorAddress, setLorAddress] = useState("");
  const [lorCity, setLorCity] = useState("");

  const [showLocationPicker, setShowLocationPicker] = useState(false);

  const [isNew, setIsNew] = useState(true);

  const handleLocationPicker = (e) => {
    e.preventDefault();
    setShowLocationPicker(true);
  };

  const handleLocationSelect = (newLocation) => {
    console.log("newLocation", newLocation);
    setLorLat(newLocation.lat.toString());
    setLorLon(newLocation.lng.toString());
    setShowLocationPicker(false); // Close the modal after setting the location
  };

  const handleClose = (e) => {
    setShowLocationPicker(false);
  };

  const resetForm = () => {
    setSearchFieldReset(true);
    setResetSearchFields(true);
    setLocation({});
    setIsNew(true);
    setLorCustomer("");
    setLorDescription("");
    setLorLon("");
    setLorLat("");
    setLorAddress("");
    setLorCity("");
    setLorPlant("");
    setSubmitErrors({});
  };

  const handleSubmit = async () => {
    setIsSubmitLoading(true);
    try {
      const data = {
        lorName: isNew ? locRef?.current?.inputValue : location?.retField1,
        lorLocId: isNew ? null : location?.retId,
        lorCustomer: lorCustomer,
        lorDescription: lorDescription,
        lorLon: lorLon,
        lorLat: lorLat,
        lorNew: isNew,
        lorPlant: lorPlant,
        lorStatus: 1,
        lorActive: 1,
        lorAddress: lorAddress,
        lorCity: lorCity,
      };

      let locationErrors = {};
      if (isNew) {
        locationErrors = locationApprovalValidation(data, true);
      } else {
        locationErrors = locationApprovalValidation(data, false);
      }
      console.log("locationErrors", locationErrors);
      if (Object.keys(locationErrors).length > 0) {
        setSubmitErrors(locationErrors);
        toast.error("There was an error adding Location", {
          autoClose: 5000,
          containerId: "Main",
        });
        return;
      } else {
        const response = await createLocationApprovalRequest(data);
        console.log("save response", response);
        if (response.status === 200) {
          toast.success(response.data, {
            autoClose: 5000,
            containerId: "Main",
          });

          resetForm();
          handleDrawerClose();
          setUpdateNeeded(true);
        } else {
          toast.error(response.data, {
            autoClose: 5000,
            containerId: "Main",
          });
        }
      }
    } catch (error) {
      console.log("error", error);
      toast.error(error.response.data, {
        autoClose: 5000,
        containerId: "Main",
      });
      console.error(error);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <div styles={{ width: "80vw", boxShadow: "none" }}>
      <CardContent>
        <div className="ui top attached tabular menu">
          <Tab
            Icon={BiMapPin}
            onClick={() => {
              setTab(1);
            }}
            active={tab === 1}
            errors={Object.keys(submitErrors).length > 0}
            label="Location"
            resizeForSmallerScreens={true}
          />
        </div>
        <div
          className="ui bottom attached active tab segment"
          style={{ display: tab === 1 ? "block" : "none" }}
        >
          <form className="ui form">
            <div className="ui segment">
              <h4 className="ui dividing header">Location Details</h4>
              <div className="field">
                <SearchDropdown
                  required={true}
                  ref={locRef}
                  clearable={true}
                  label="Location"
                  onClear={() => {
                    setLocation({});
                    setLorLat("");
                    setLorLon("");
                    setIsNew(true);
                  }}
                  // authenticated={true}
                  // field={"pickupLocation"}
                  // module={MODULES.Finance}
                  // form={FORMS.RATE_MANAGER.LOCATIONS.form}
                  // style={{minWidth: "500px", maxWidth: "500px"}}
                  // key={currentKey}
                  // multiGrid={true}
                  // multiGridCurrentValue={
                  //     currentLocation ? currentLocation.locName : ""
                  // }
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  api={getOtherRefDetails}
                  threshold={3}
                  apiDependency={{
                    type: "location",
                    value: "",
                  }}
                  returnFullObject={true}
                  onResultSelect={(data) => {
                    console.log("location", data);
                    setLocation(data);
                    setLorLat(data?.retField10);
                    setLorLon(data?.retField9);
                    setIsNew(false);
                  }}
                  //   fieldInfo={{
                  //     tableName: "masterdata.tms_m_locations",
                  //     primaryKey: "loc_id",
                  //     fieldName: "loc_name",
                  //     id: location?.retId,
                  //   }}
                  error={submitErrors?.lorName}
                  resetError={() =>
                    setSubmitErrors((prevState) => {
                      const { lorName: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              </div>

              <div className="two fields">
                <SearchDropdown
                  key={1}
                  editMode={false}
                  required={true}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setLorCustomer("");
                  }}
                  onResultSelect={(data) => setLorCustomer(data)}
                  api={getOtherRefSearchDropdown}
                  apiDependency={
                    userData.type === 1
                      ? {
                          type: "stakeholder_type",
                          value: "Customer",
                        }
                      : {
                          type: "user_stakeholder",
                          value: "Requesting Customer",
                          param2: user.username,
                        }
                  }
                  label="Customer"
                  error={submitErrors?.lorCustomer}
                  resetError={() =>
                    setSubmitErrors((prevState) => {
                      const { lorCustomer: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
                <SearchDropdown
                  key={2}
                  editMode={false}
                  required={true}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  clearable={true}
                  onClear={() => {
                    setLorPlant("");
                  }}
                  onResultSelect={(data) => setLorPlant(data)}
                  api={getOtherRefSearchDropdown}
                  apiDependency={
                    userData.type === 1
                      ? {
                          type: "stakeholder_type",
                          value: "Shipper",
                          param2: lorCustomer ? lorCustomer : "",
                        }
                      : {
                          type: "user_stakeholder",
                          value: "Shipper",
                          param1: lorCustomer ? lorCustomer : "",
                          param2: user.username,
                        }
                  }
                  label="Shipper/Plant"
                  readOnly={!lorCustomer}
                  error={submitErrors?.lorPlant}
                  resetError={() =>
                    setSubmitErrors((prevState) => {
                      const { lorPlant: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              </div>
              <div className="field">
                <Input
                  label="Description"
                  name="locDescription"
                  value={lorDescription}
                  onChange={(e) => {
                    setLorDescription(e.target.value);
                  }}
                />
              </div>
              <div
                className="two fields"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Input
                  required={true}
                  label="Latitude"
                  name="lorLat"
                  value={lorLat}
                  onChange={(e) => {
                    setLorLat(e.target.value);
                  }}
                  error={submitErrors?.lorLat}
                  resetError={() =>
                    setSubmitErrors((prevState) => {
                      const { lorLat: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  readOnly={true}
                />
                <Input
                  required={true}
                  label="Longitude"
                  name="lorLon"
                  value={lorLon}
                  onChange={(e) => {
                    setLorLon(e.target.value);
                  }}
                  error={submitErrors?.lorLon}
                  resetError={() =>
                    setSubmitErrors((prevState) => {
                      const { lorLon: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  readOnly={true}
                />
                <button
                  className="ui primary button"
                  onClick={(e) => handleLocationPicker(e)}
                  style={{
                    marginTop: "1.9rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                >
                  <MapPin size={15} />
                </button>
              </div>
              {showLocationPicker && (
                <div className="ui dimmer modals visible active">
                  <div
                    className="ui standard modal visible active"
                    style={{ width: "80%", height: "auto" }}
                  >
                    <div className="content">
                      <MapComponent
                        type={MAP_TYPES.PICK}
                        onLocationSelect={handleLocationSelect}
                        pickLocation={
                          lorLon && lorLat
                            ? {
                                lat: parseFloat(lorLat),
                                lng: parseFloat(lorLon),
                              }
                            : { lat: 6.9271, lng: 79.8612 }
                        }
                        handleClose={handleClose}
                      />
                    </div>
                  </div>
                </div>
              )}

              {isNew && (
                <div className="two fields">
                  <Input
                    required={isNew ? true : false}
                    label="Address"
                    error={submitErrors?.lorAddress}
                    resetError={() =>
                      setSubmitErrors((prevState) => {
                        const { lorAddress: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    name="conAddress"
                    value={lorAddress}
                    onChange={(e) => {
                      setLorAddress(e.target.value);
                    }}
                  />
                  <SearchDropdown
                    key={1}
                    // ref={cityRef}
                    required={isNew ? true : false}
                    reset={searchFieldReset}
                    // multiGrid={true}
                    // multiGridCurrentValue={contactData.conCityValue}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onClear={() => {
                      setLorCity(null);
                    }}
                    onResultSelect={(data) => setLorCity(data)}
                    api={cityStartsWith}
                    apiDependency={{}}
                    // fieldInfo={{
                    //   tableName: "masterdata.tms_m_reg_cities",
                    //   primaryKey: "cit_id",
                    //   fieldName: "cit_city",
                    //   id: contactData.conCity,
                    // }}
                    label="City"
                    error={submitErrors?.lorCity}
                    resetError={() =>
                      setSubmitErrors((prevState) => {
                        const { lorCity: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                </div>
              )}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              <Button
                template="create"
                onClick={handleSubmit}
                isLoading={isSubmitLoading}
                editMode={false}
                create={true}
              />
            </div>
          </form>
        </div>
      </CardContent>
    </div>
  );
};

export default ApproveLocation;
